import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 7v-1a2 2 0 0 1 2 -2h2","key":"svg-0"}],["path",{"d":"M4 17v1a2 2 0 0 0 2 2h2","key":"svg-1"}],["path",{"d":"M16 4h2a2 2 0 0 1 2 2v1","key":"svg-2"}],["path",{"d":"M16 20h2a2 2 0 0 0 2 -2v-1","key":"svg-3"}],["path",{"d":"M5 12l14 0","key":"svg-4"}]]

const IconScan = createReactComponent('outline', 'scan', 'Scan', __iconNode);

export default IconScan;